export const logShare = (platform, url) => {
    if (typeof window !== undefined) {
        window.dataLayer.push({
            'clickURL': url,
            'clickPlatform': platform,
            'event': 'shareClick'
        });
    }
}

export const utmUrl = (url, social, encode = true) => {
    const refUrl = `${url}?utm_source=${social}&utm_medium=referral&utm_campaign=stories_social_share&utm_content=share_this_story`
    return encode
        ? encodeURIComponent(refUrl)
        : refUrl
}

export const twitterShare = (url, text, handle) => {
    return {
        link: `https://twitter.com/intent/tweet?text=${text}&via=${handle}&url=${utmUrl(url, 'twitter')}`,
        platform: 'Twitter'
    }
}

export const facebookShare = (appId, url, text) => {
    if (typeof window !== 'undefined') {
        logShare('facebook', url)
        return () => {
            window.FB.init({
                appId,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v4.0',
            })

            window.FB.ui({
                method: 'share',
                href: utmUrl(url, 'facebook', false),
                quote: text,
            })
        }
    }
    return () => null
}

export const linkedInShare = (url, text) => {
    return {
        link: `https://www.linkedin.com/shareArticle?mini=true&url=${utmUrl(url, 'linkedin')}&title=${text}`,
        platform: 'LinkedIn',
    }
}
